import React from 'react';

import SatRadio from '@components/common/satUI/SatRadio';

const MainContractDetailName = props => {
  const { vipVaNameType, vipVaNameList, onChange } = props;

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2>주계약 세부상품명</h2>
      </div>
      <div className="check-box">
        <SatRadio
          value={vipVaNameType}
          options={vipVaNameList.map(item => {
            return { label: item.dispName, value: item.code };
          })}
          onChange={onChange}
          name="vipVaNameTypeRadio"
        />
      </div>
    </React.Fragment>
  );
};

export default MainContractDetailName;
